import React from 'react';
import PropTypes from 'prop-types';
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import RightDrawerDesktopHead from "./components/RightDrawerDesktopHead";
import {Grid} from "@mui/material";

RightDrawerDesktop.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    underTitle: PropTypes.element,
    openMaxWidth: PropTypes.bool,
    withoutHeaderBorder: PropTypes.bool,
    customWidth: PropTypes.string,
    customContentPadding: PropTypes.string,
};

function RightDrawerDesktop({title, subtitle, underTitle = null, open = false, onClose = () => {}, disablePortal= false, openMaxWidth = false, withoutHeadBorder = false, customWidth = "", customContentPadding = "", ...props}) {
    return (
        <SwipeableDrawer
            anchor={'right'}
            open={open}
            onClose={onClose}
            onOpen={() => {}} // onOpen is not used in this component but required
            sx={{
                '.MuiDrawer-paper': {
                    width: openMaxWidth ? '100vw' : customWidth !== '' ? customWidth : "30%",
                    borderTopLeftRadius: 24,
                    borderBottomLeftRadius: 24,
                    position: 'fixed',
                }
            }}
            disablePortal={disablePortal}
        >
            <RightDrawerDesktopHead
                title={title}
                subtitle={subtitle}
                onClose={onClose}
                withoutBorder={withoutHeadBorder}
            >
                {underTitle}
            </RightDrawerDesktopHead>
            <Grid container direction={"column"} sx={{paddingX: customContentPadding !== "" ? customContentPadding : "40px", marginY: "24px"}}>
                {props.children}
            </Grid>
        </SwipeableDrawer>
    );
}

export default RightDrawerDesktop;